import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
// material
import { Tooltip, Stack, IconButton, TextField, Menu, OutlinedInput, Fade, Autocomplete, ListItemText, Checkbox, Chip, FormControl, InputLabel, Select, MenuItem, Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Moment from 'moment';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';
import XLSX from 'sheetjs-style';
import * as FileSaver from 'file-saver';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';

// -----------------------------------------------------------------------------------------------------

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        sx: {
            backgroundColor: '#fbe9e7', // Set the background color here
            maxHeight: '200px',
            width: '200px',// Set the max height here
        }
    }
};





const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];


const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


const controlsData = [
    {
        Id: "ServiceTimeContributionReportControls",
        value: "ExecutiveName,Client,Project,TeamName,Activity,ServiceDate,ServiceMonth",
    },
];

const controlsList = controlsData.map((control) => ({
    ...control,
    values: control.value.split(","),
}));


const outputData = [
    {
        Id: "0",
        value: "Hours",
    },
    {
        Id: "1",
        value: "Percentage",
    },
];
export default function ServiceTimeContributionComponent() {
    const { enqueueSnackbar } = useSnackbar();


    // CSV DATA



    const [controls, setControls] = useState([]);
    const [serviceTimeContribution, setServiceTimeContribution] = useState([]);
    const [department, setDepartment] = useState([]);
    const [startDateValue, setStartDateValue] = useState();
    const [endDateValue, setEndDateValue] = useState();
    const [client, setClient] = useState([]);
    const [executive, setExecutive] = useState([]);
    const [hideAll, setHideAll] = useState(false);
    const [rowControlValues, setRowControlValues] = useState([]);
    const [columnControlValues, setColumnControlValues] = useState('');
    const [isLoading, setIsLoading] = useState();
    const [pageSize, setPageSize] = useState(10);

    console.log("client", client);
    const columns = [];
    const rows = [];

    serviceTimeContribution.forEach((item, index) => {
        const row = { id: index + 1 };
        Object.entries(item).forEach(([key, value]) => {
            if (index === 0) {
                columns.push({
                    field: key,
                    headerName: key,
                    width: 150
                });
            }
            row[key] = value;
        });
        rows.push(row);
    });

    console.log("Columns:", columns);
    console.log("Rows:", rows);



    const handleStart = (newValue) => {
        console.log("newValue", newValue);
        setStartDateValue(newValue)
    };
    const handleEnd = (date) => {
        if (Moment(date).isBefore(startDateValue)) {
            // End date is before the start date, show validation error
            enqueueSnackbar('End date cannot be less than start date');

        } else {
            setEndDateValue(date);
        }


    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const fileExtention = '.xlsx';

    const FileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const exportToExcel = async () => {
        const filteredData = serviceTimeContribution.map((entry) => {
            const filteredEntry = {};
            columns.forEach((column) => {
                filteredEntry[column.field] = entry[column.field];
            });
            return filteredEntry;
        });

        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: FileType });
        FileSaver.saveAs(data, `ServiceTimeContributionReport${fileExtention}`);
    };





    // const handleChange = (event, id) => {
    //    const { value } = event.target;

    //    if (id === 'row-controls-select') {
    //        console.log('Row control values:', value);
    //        setRowControlValues(value);
    //        setColumnControlValues(prevValues =>
    //            prevValues.filter(val => !value.includes(val))
    //        );
    //    } else if (id === 'column-controls-select') {
    //        console.log('Column control values:', value);
    //        const selectedRowControlValues = rowControlValues.filter(
    //            val => !value.includes(val)
    //        );
    //        setColumnControlValues(value);
    //        setRowControlValues(selectedRowControlValues.filter(val => !value.includes(val)));
    //    }
    // };

    const handleChange = (event, id) => {
        const { value } = event.target;

        if (id === 'row-controls-select') {
            console.log('Row control values:', value);
            setRowControlValues(value);
            setColumnControlValues(''); // Reset column control value when row control changes
        } else if (id === 'column-controls-select') {
            console.log('Column control values:', value);
            const selectedRowControlValues = rowControlValues.filter(
                val => !value.includes(val)
            );
            setColumnControlValues(value); // Update column control value
            setRowControlValues(
                selectedRowControlValues.filter(val => !value.includes(val))
            );
        }
    };








    useEffect(() => {
        URLS.getDepartmentDropDown()
            .then((response) => {

                setDepartment(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getClientsPopOverDropDown()
            .then((response) => {

                setClient(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getExecutivesDropDown()
            .then((response) => {

                setExecutive(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getControlsDropDown()
            .then((response) => {
                const controlsData = response.data;
                const controlsArray = controlsData.map(data => ({
                    Id: data.Id,
                    value: data.value.split(",").map(value => value.trim())
                }));
                setControls(controlsArray);
            })
            .catch((error) => {
                console.log("Error:", error);
            });

    }, []);


    // Department DropDown

    const [DeptValue, setDeptValue] = useState('');
    const handleSelectedDepartment = (id) => {
        console.log("id", id);
        setDeptValue(id);
    };
    const SelectDepartment = () => {
        setDeptValue("");


    };

    // Client DropDown
    const [clientValue, setClientValue] = useState([]);
    // const handleSelectedClient = (id) => {
    //    console.log("Selected client ID:", id);
    //    setClientValue((prevSelectedClients) => [...prevSelectedClients, id]);
    // };

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const countSelectedClients = (selectedClients) => {
        return selectedClients.length;
    };

    const handleSelectedClient = (selectedClients) => {

        const selectedClientIds = selectedClients.map((client) => client.Id);
        setClientValue(selectedClientIds);
    };

    const filterOptions = (options, { inputValue }) => {
        if (inputValue.length >= 3) {
            const inputValueLowerCase = inputValue.toLowerCase();
            const matchingOptions = options.filter((option) =>
                option.Name.toLowerCase().includes(inputValueLowerCase)
            );

            // Sort the matchingOptions array to put selected options on top
            const sortedOptions = matchingOptions.sort((a, b) => {
                const isSelectedA = clientValue.includes(a.Id);
                const isSelectedB = clientValue.includes(b.Id);

                if (isSelectedA && !isSelectedB) return -1; // a is selected, b is not selected (a comes first)
                if (!isSelectedA && isSelectedB) return 1; // b is selected, a is not selected (b comes first)
                return 0; // both are selected or unselected (keep the same order as in matchingOptions)
            });

            return sortedOptions;
        }

        return client.filter((option) => clientValue.includes(option.Id)); // Show selected records if fewer than 3 letters are entered
    };


   


    const SelectClient = () => {
        setClientValue([]);
    };

    console.log("Selected IDs:", clientValue);
    // Executive DD
    const [executiveValue, setExecutiveValue] = useState('');
    const handleSelectedExecutive = (id) => {
        console.log("idexe", id);
        setExecutiveValue(id);
    };
    const SelectExecutive = () => {
        setExecutiveValue("");


    };

    // test Accordion
    const [expanded, setExpanded] = useState('panel1');

    const handleChangeAccordion = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // At output Dropdown
    const [output, setOutput] = useState('0');
    const handleSelectedOutput = (value) => {
        console.log("value", value);
        setOutput(value);

    };

    const handleGenerate = () => {

        const payload = {
            rptFromDate: startDateValue,
            rptToDate: endDateValue,
            DepartmentId: DeptValue,
            ExecutiveId: executiveValue,
            ClientId: clientValue,
            StaticColumns: rowControlValues,
            PivotColumn: columnControlValues,
            OutputAs: output || '0'
        }
        console.log("Selected IDs:", clientValue);
        if (rowControlValues.length === 0) {
            // Display an error message or perform any validation action
            enqueueSnackbar("Please select Row");

            // You can disable the generate button or show an error message to the user
        } else if (columnControlValues.length === 0) {
            enqueueSnackbar("Please select Column");
        }  else {

            setIsLoading(true);
            setHideAll(true);
            URLS.getServiceTimeContributionReport(payload)
                .then((response) => {
                    if (!response.data || response.data.length === 0) { // Check if 'data' field is empty or has no elements
                        setIsLoading(false);
                        enqueueSnackbar("No data found", { variant: 'error' });
                    } else {
                        setServiceTimeContribution(response.data);
                        setIsLoading(false);
                        enqueueSnackbar("Report Generated", { variant: 'success' });
                    }
                })
                .catch(error => {
                    // On error
                    handleError(error, enqueueSnackbar);
                    setIsLoading(false);
                });


        };
    }

    const onResetClick = () => {
        // handelSelectExecutive();
        setStartDateValue(new Date());
        setEndDateValue(new Date());
        setDeptValue("");
        setExecutiveValue("");
        setClientValue([]);
        setRowControlValues([]);
        setColumnControlValues([]);
        setServiceTimeContribution([]);
    };

    return (
        <div>



            <Stack spacing={2}>
                <Stack direction="row" spacing={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            label="Start Date"
                            inputFormat="dd/MMM/yyyy"
                            value={Moment(startDateValue).format('DD-MMM-yyyy')}
                            onChange={handleStart}
                            renderInput={(params) => <TextField fullWidth size="small" {...params} />} />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                            label="End Date"
                            inputFormat="dd/MMM/yyyy"
                            value={Moment(endDateValue).format('DD-MMM-yyyy')}
                            onChange={handleEnd}
                            renderInput={(params) => <TextField fullWidth size="small" {...params} />} />
                    </LocalizationProvider>

                    <FormControl
                        fullWidth
                        size="small" >
                        <InputLabel inputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Department</InputLabel>
                        <Select
                            label="Department"
                            value={DeptValue}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7', // Set the background color here
                                        maxHeight: '200px',
                                        width: '200px',// Set the max height here
                                    }
                                }
                            }}
                        >
                            <MenuItem key={0} value={""} onClick={() => SelectDepartment()}>Select</MenuItem>
                            {department.map((dept) => (
                                <MenuItem key={dept.Id} value={dept.Id} onClick={() => handleSelectedDepartment(dept.Id, dept.TeamName)}> {dept.TeamName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        fullWidth
                        size="small">
                        <InputLabel inputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Executives</InputLabel>
                        <Select
                            label="Executives"
                            value={executiveValue}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7', // Set the background color here
                                        maxHeight: '200px',
                                        width: '200px',// Set the max height here
                                    }
                                }
                            }}>
                            <MenuItem key={0} value={""} onClick={() => SelectExecutive()}>Select</MenuItem>
                            {executive.map((dept) => (
                                <MenuItem key={dept.Id} value={dept.Id} onClick={() => handleSelectedExecutive(dept.Id, dept.Name)}> {dept.Name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    {/* <FormControl fullWidth size="small"> */}
                    {/*    <InputLabel inputLabelProps={{ style: { color: 'green', fontSize: '14px' } }}> */}
                    {/*        Client */}
                    {/*    </InputLabel> */}
                    {/*    <Select */}
                    {/*        label="Client" */}
                    {/*        multiple */}
                    {/*        value={clientValue} // clientValue should be an array for multiple selection */}
                    {/*     onChange={(event) => setClientValue(event.target.value)} // Update clientValue using event.target.value */}
                    {/*        MenuProps={{ */}
                    {/*            style: { maxHeight: '200px' }, */}
                    {/*            getContentAnchorEl: null, // Removes the default offset of the menu */}
                    {/*            anchorOrigin: { */}
                    {/*                vertical: 'bottom', */}
                    {/*                horizontal: 'left', */}
                    {/*            }, */}
                    {/*        }} */}
                    {/*    > */}
                    {/*        <MenuItem key={0} value={''} onClick={() => SelectClient()}> */}
                    {/*            Select */}
                    {/*        </MenuItem> */}
                    {/*        {client.map((ofc) => ( */}
                    {/*            <MenuItem */}
                    {/*                sx={{ width: '20px' }} */}
                    {/*                key={ofc.Id} */}
                    {/*                value={ofc.Id} */}
                    {/*                onClick={() => handleSelectedClient(ofc.Id, ofc.Name)} */}
                    {/*            > */}
                    {/*                {ofc.Name} */}
                    {/*            </MenuItem> */}
                    {/*        ))} */}
                    {/*    </Select> */}
                    {/* </FormControl> */}

                    {/* <Autocomplete */}
                    {/*    fullWidth */}
                    {/*    multiple */}
                    {/*    options={client} */}
                    {/*    getOptionLabel={(option) => option.Name} */}
                    {/*    value={client.filter((option) => clientValue.includes(option.Id))} */}
                    {/*    onChange={(event, selectedClients) => handleSelectedClient(selectedClients)} */}
                    {/*    disableCloseOnSelect */}
                    {/*    selectOnFocus */}
                    {/*    size="small" */}
                    {/*    renderInput={(params) => ( */}
                    {/*        <TextField */}
                    {/*            {...params} */}
                    {/*            label="Client" */}
                    {/*            inputLabelProps={{ */}
                    {/*                style: { fontSize: '14px' }, */}
                    {/*            }} */}
                    {/*        /> */}
                    {/*    )} */}
                    {/* /> */}


                    {/* <Autocomplete */}
                    {/*    disablePortal */}
                    {/*    id="combo-box-demo" */}
                    {/*    fullWidth */}
                    {/*    multiple */}
                    {/*    options={client} */}
                    {/*    getOptionLabel={(option) => option.Name} */}
                    {/*    value={client.filter((option) => clientValue.includes(option.Id))} */}
                    {/*    onChange={(event, selectedClients) => handleSelectedClient(selectedClients)} */}
                    {/*    disableCloseOnSelect */}
                    {/*    selectOnFocus */}
                    {/*    size="small" */}
                    {/*    filterOptions={filterOptions} // Using the custom filter function */}
                    {/*    renderInput={(params) => ( */}
                    {/*        <TextField */}
                    {/*            {...params} */}
                    {/*            label="Client" */}
                    {/*            inputLabelProps={{ */}
                    {/*                style: { fontSize: '14px' }, */}
                    {/*            }} */}
                    {/*        /> */}
                    {/*    )} */}
                    {/* /> */}




                    <Autocomplete
                        fullWidth
                        size="small"
                        multiple
                        disableCloseOnSelect
                        options={client}
                        getOptionLabel={(option) => option.Name}
                        value={client.filter((option) => clientValue.includes(option.Id))}
                        filterOptions={filterOptions}
                        onChange={(event, selectedClients) => handleSelectedClient(selectedClients)}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.Name}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Client"
                                variant="outlined"
                                inputLabelProps={{
                                    style: { fontSize: '14px' },
                                }}
                            />
                        )}
                        renderTags={(value, getTagProps) => (
                            <div>
                               
                                {value.length > 0 && (
                                    <Chip
                                        size="small"
                                        label={`${value.length} selected`}
                                        style={{ backgroundColor: '#E0E0E0', fontSize:'12px' }}
                                    />
                                )}
                            </div>
                        )}
                    />




                </Stack>


                <Stack direction="row" spacing={2}>

                    <FormControl fullWidth size="small">
                        <InputLabel id="row-controls-label">Row</InputLabel>
                        <Select
                            labelId="row-controls-label"
                            id="row-controls-select"
                            value={rowControlValues}
                            multiple
                            onChange={event => handleChange(event, 'row-controls-select')}
                            input={<OutlinedInput label="Row*" />}
                            renderValue={selected =>
                                selected
                                    .map(value => {
                                        const control = controlsList.find(item =>
                                            item.values.includes(value)
                                        );
                                        return control ? control.values.find(v => v === value) : '';
                                    })
                                    .join(', ')
                            }
                            MenuProps={MenuProps}
                        >
                            {controlsList.flatMap(control =>
                                control.values.map(value => {
                                    if (!columnControlValues.includes(value)) {
                                        return (
                                            <MenuItem key={value} value={value}>
                                                <Checkbox checked={rowControlValues.includes(value)} />
                                                <ListItemText primary={value} />
                                            </MenuItem>
                                        );
                                    }
                                    return null;
                                })
                            )}
                        </Select>
                    </FormControl>


                    <FormControl fullWidth size="small">
                        <InputLabel id="column-controls-label">Column</InputLabel>
                        <Select
                            labelId="column-controls-label"
                            id="column-controls-select"
                            value={columnControlValues} // Single selected value instead of an array
                            onChange={event => handleChange(event, 'column-controls-select')}
                            input={<OutlinedInput label="Column*" />}
                            renderValue={selected => {
                                const control = controlsList.find(item =>
                                    item.values.includes(selected)
                                );
                                return control ? control.values.find(v => v === selected) : '';
                            }}
                            MenuProps={MenuProps}
                        >
                            {controlsList.flatMap(control =>
                                control.values.map(value => {
                                    if (!rowControlValues.includes(value)) {
                                        return (
                                            <MenuItem key={value} value={value}>
                                                <Checkbox checked={columnControlValues === value} /> {/* Single value comparison */}
                                                <ListItemText primary={value} />
                                            </MenuItem>
                                        );
                                    }
                                    return null;
                                })
                            )}
                        </Select>
                    </FormControl>





                    <FormControl
                        fullWidth
                        size="small">
                        <InputLabel inputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Output As</InputLabel>
                        <Select
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: '#fbe9e7', // Set the background color here
                                        maxHeight: '200px',
                                        width: '200px',// Set the max height here
                                    }
                                }
                            }}
                            label="Output As"
                            value={output}>

                            {outputData.map((ofc) => (
                                <MenuItem key={ofc.Id} value={ofc.Id} onClick={() => handleSelectedOutput(ofc.Id, ofc.value)}> {ofc.value}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    <Tooltip title="Filter">
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleGenerate}
                        ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                    </Tooltip >

                    <Tooltip title="Reset">
                        <Button
                            variant="contained"
                            size="small"
                            onClick={onResetClick}
                        ><Icon icon="ic:twotone-restart-alt" width="25px" height="25px" /></Button>
                    </Tooltip >

                    <Tooltip title="Export">
                        <IconButton id="fade-button"
                            aria-controls={open ? 'fade-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick} sx={{ marginBottom: 1 }} >
                            <Icon height="15px" icon="ic:baseline-density-small" />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        id="fade-menu"
                        MenuListProps={{
                            'aria-labelledby': 'fade-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Fade}
                    >
                        <MenuItem onClick={handleClose}>  <Button sx={{ color: 'black' }} size="small" onClick={exportToExcel}>Export to excel</Button></MenuItem>


                    </Menu>

                </Stack>


            </Stack>



            {hideAll ?
                <div style={{ height: 395, width: '100%', marginTop: 6 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        density={'compact'}
                        pageSize={pageSize}
                        disableSelectionOnClick
                        rowsPerPageOptions={[5, 10, 20]}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        getRowId={(row) => row.id}
                        components={{
                            Toolbar: GridToolbar,
                        }}
                    />
                </div> : ''}

            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}

        </div>
    );
}